// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"4af02abf","388":"30b13d20","396":"96957c8d","421":"25b1d5ea","655":"d3e4275c","975":"8df4c31a"}[chunkId] + ".chunk.css";
};